import { render, staticRenderFns } from "./DropdownFilters.vue?vue&type=template&id=794761c2&scoped=true&lang=pug"
import script from "./DropdownFilters.vue?vue&type=script&lang=js"
export * from "./DropdownFilters.vue?vue&type=script&lang=js"
import style0 from "./DropdownFilters.vue?vue&type=style&index=0&id=794761c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794761c2",
  null
  
)

export default component.exports